// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { getLoginServerBaseUrl } from '@/utils/envConfig';
import { envConfigs, EnvType } from '../../../config/envConfig';

/**
 * 获取登录服务的完整 URL
 * 所有环境都使用完整 URL（LOGIN_SERVER_BASE_URL）
 * 该值由 config.[env].ts 中的 define 配置在构建时注入
 */
function getLoginServerPath(url: string): string {
  const envConfig = envConfigs[REACT_APP_ENV as EnvType];
  const baseURL = envConfig?.loginServerBaseUrl;
  // const baseURL = getLoginServerBaseUrl();
  return `${baseURL}${url}`;
}

// 登录服务请求包装函数
const devopsLoginServer = {
  // POST 请求
  post: (url: string, data?: any) => {
    const requestUrl = getLoginServerPath(url);
    return request(requestUrl, {
      method: 'POST',
      data,
      skipErrorHandler: false,
      getResponse: false, // false 表示只返回数据部分，不返回完整响应对象
    });
  },
  
  // GET 请求
  get: (url: string, config?: { params?: any }) => {
    const requestUrl = getLoginServerPath(url);
    const params = config?.params;
    // 将 params 转为 query string
    const queryString = params 
      ? '?' + Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&')
      : '';
    return request(`${requestUrl}${queryString}`, {
      method: 'GET',
      skipErrorHandler: false,
      getResponse: false,
    });
  },
};

export default devopsLoginServer;

